import { render, staticRenderFns } from "./details-introduce.vue?vue&type=template&id=542107c9&scoped=true"
import script from "./details-introduce.vue?vue&type=script&lang=js"
export * from "./details-introduce.vue?vue&type=script&lang=js"
import style0 from "./details-introduce.vue?vue&type=style&index=0&id=542107c9&prod&scoped=true&lang=css"
import style1 from "./details-introduce.vue?vue&type=style&index=1&id=542107c9&prod&lang=css"
import style2 from "./details-introduce.vue?vue&type=style&index=2&id=542107c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542107c9",
  null
  
)

export default component.exports